var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 18.0625H17.6875C18.3433 18.0625 18.875 17.5308 18.875 16.875V7.375C18.875 6.71916 18.3433 6.1875 17.6875 6.1875H9.375V18.0625Z",
    fill: "url(#paint0_linear_36087_4199)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.0625C16.5 18.7183 17.0317 19.25 17.6875 19.25H24.8125C25.4683 19.25 26 18.7183 26 18.0625V8.5625C26 7.90666 25.4683 7.375 24.8125 7.375H16.5V18.0625Z",
    fill: "url(#paint1_linear_36087_4199)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.1875C9.375 5.53166 8.84334 5 8.1875 5C7.53166 5 7 5.53166 7 6.1875V26.375C7 27.0308 7.53166 27.5625 8.1875 27.5625C8.84334 27.5625 9.375 27.0308 9.375 26.375V6.1875Z",
    fill: "url(#paint2_linear_36087_4199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36087_4199",
    x1: 9.375,
    y1: 6.1875,
    x2: 20.9604,
    y2: 15.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EAC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36087_4199",
    x1: 16.5,
    y1: 7.375,
    x2: 28.0854,
    y2: 16.6433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36087_4199",
    x1: 7,
    y1: 12.0624,
    x2: 9.375,
    y2: 12.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999997,
    stopColor: "#C2C2C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlag);
export default __webpack_public_path__ + "static/media/ic_flag.517d5ff5eb706c7ec3d056ced04f04c0.svg";
export { ForwardRef as ReactComponent };